.card {
  display: flex;
  flex-direction: column;
  margin: 0;
  list-style: none;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}
.boot {
  padding: 10px 24px;
}
.link {
  padding: 6px 20px;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-divider);
  font-family: var(--font-heading);
  font-size: 15px;
}
.boot .row {
  padding: 12px 0;
}
.link .row {
  padding: 13px 0;
}
.boot .upcoming {
  opacity: 0.5;
}
.link .upcoming {
  opacity: 0.7;
}

.text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.label {
  color: var(--color-text);
  font-weight: 700;
}
.detail {
  font-size: 12px;
  color: var(--color-neutral-600);
  font-weight: 500;
}
.status {
  font-weight: 800;
  color: var(--color-neutral-500);
}
.done .status {
  color: var(--color-success);
}

.dots {
  display: flex;
  gap: 4px;
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--color-accent);
  animation: evx-dotJump 1s ease-in-out infinite;
}
.dot:nth-child(2) {
  animation-delay: 0.15s;
}
.dot:nth-child(3) {
  animation-delay: 0.3s;
}
